// src/i18n/locales/en/categories.ts
export const enCategoriesTranslations = {
	categories: {
		// Categories page
		title: 'Menu Categories',
		subtitle: 'Organize your menu items into categories',
		addCategory: 'Add Category',
		editCategory: 'Edit Category',
		deleteCategory: 'Delete Category',

		// Category properties
		name: 'Category Name',
		description: 'Description',
		image: 'Category Image',
		displayOrder: 'Display Order',
		published: 'Published',
		thumbnail: 'Thumbnail',
		categoryImage: 'Category Image',
		parentCategory: 'Parent Category',
		noParent: 'No Parent',
		addMainCategory: 'Add Main Category',
		addSubcategory: 'Add Subcategory',
		subcategories: 'Subcategories',
		mainCategory: 'Main Category',
		subcategory: 'Subcategory',
		categoryType: 'Category Type',

		// Status labels
		draft: 'Draft',

		// Empty states
		noCategories: 'No categories yet',
		noCategoriesYet: 'You don\'t have any categories yet',
		noCategoriesTooltip: 'Create categories to organize your menu items',
		createFirstCategory: 'Create First Category',
		noMatchingCategories: 'No matching categories found',
		tryAdjustingFilters: 'Try adjusting your search or filters',
		noSubcategories: 'No subcategories yet',
		addSubcategoryDescription: 'Create subcategories to organize your menu items better',
		addFirstSubcategory: 'Add First Subcategory',

		// Actions
		publish: 'Publish',
		unpublish: 'Unpublish',
		backToCategories: 'Back to Categories',
		noDescription: 'No description',
		itemCount: '{{count}} item',
		itemCount_plural: '{{count}} items',
		lastUpdated: 'Last updated',
		menuItems: 'Menu Items',
		viewItems: 'View Items',
		clickToManage: 'Click to manage',
		viewParent: 'View Parent Category',

		// Info messages
		mainCategoryInfo: 'Main Category Structure',
		mainCategoryDescription: 'Main categories are used to organize subcategories. Menu items can only be added to subcategories, not main categories.',

		// Category details
		categoryDetails: 'Category Details',

		// Modals and confirmations
		deleteTitle: 'Delete Category',
		deleteMessage: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
		deleteConfirmation: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',

		englishDetails: 'English Details',
		arabicDetails: 'Arabic Details',
		enName: 'English Name',
		arName: 'Arabic Name',
		arNamePlaceholder: "أدخل اسم الفئة",
		enDescription: 'English Description',
		arDescription: 'Arabic Description',
		arDescriptionPlaceholder: 'وصف هذه الفئة...',

		categoryStats: 'Category Statistics',
		createdAt: 'Created At',

		basicInformation: 'Basic Information',
		parentCategoryHelper: 'Select a parent category to create a subcategory, or leave empty for a main category',
		arabicTranslation: 'Arabic Translation',
		imageAndSettings: 'Image & Settings',
		settings: 'Category Settings',
		mainCategoryHelper: 'This will be a main category that can contain subcategories',
		unpublishedHelper: 'Category is not visible to customers',
		publishedHelper: 'Category is visible to customers',
		mainCategoryType: 'Main Category',
		subcategoryType: 'Subcategory',
		subcategoryHelper: 'This will be a subcategory under the selected parent category',

		// Errors
		notFound: 'Category Not Found',
		notFoundDescription: 'The category you are looking for does not exist or has been removed.',
		errors: {
			nameRequired: 'Category name is required',
			createFailed: 'Failed to create category. Please try again.',
			updateFailed: 'Failed to update category. Please try again.',
			arNameRequired: 'Arabic name is required when using Arabic language',

		},

		add: "Add Category",
		edit: "Edit Category",
		namePlaceholder: "Enter category name",
		descriptionPlaceholder: "Enter category description (optional)",
		uploadImage: "Click to upload image",

		updateCategory: 'Update Category',

		manageItems: 'Manage Items',
		gridView: 'Grid View',
		listView: 'List View',
		status: 'Status',

		manageMenuItems: 'Manage Menu Items',
		manageMenuItemsDescription: 'Add and organize menu items for this category. Menu items can only be added to subcategories.',
		goToMenuItems: 'Go to Menu Items',
		quickAddItem: 'Quick Add Item',
		categoryItemsHint: 'You can also add items directly from the Menu Items page',
		menuItemsCount: '{{count}} item in this category',
		menuItemsCount_plural: '{{count}} items in this category',
		noMenuItems: 'No menu items yet',
		noMenuItemsDescription: 'No menu items have been added to this category yet.',
		addFirstMenuItem: 'Add First Menu Item',
		viewAll: 'View All',
	},
};